import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

// Initalize and export Firebase.
const config = {
  apiKey: "AIzaSyBXvmTTQ7EH2mA8qGARTajpxP5jUVaa1gc",
  authDomain: "conamo-app.firebaseapp.com",
  databaseURL: "https://conamo-app.firebaseio.com",
  projectId: "conamo-app",
  storageBucket: "conamo-app.appspot.com",
  messagingSenderId: "697603992079"
};
export default firebase.initializeApp(config);



// WEBPACK FOOTER //
// ./src/components/firebase.js